import React from 'react';
import { FormControl, InputAdornment, TextField } from '@material-ui/core';
import MailOutline from '@material-ui/icons/MailOutline';
import classNames from 'clsx';
import History from 'mdi-material-ui/History';

import { ControlContainer } from 'app/components/ControlContainer';
import { UtilService } from 'app/services/util.service';
import { EMailControlProps } from './EMailControl.interfaces';
import { LabelEnum } from 'app/shared/enums';
import isSafariOrIOS from 'app/shared/helpers/isSafariOrIos';
import { useEmailControl } from 'app/shared/hooks/controls/useEmailControl';
import { useStyles } from './EMailControl.styles';
import { TipMessage } from 'app/components/TipMessage';

export default function EMailControl(props: EMailControlProps) {
  const classes = useStyles();

  const {
    disabled,
    input,
    meta,
    label,
    placeholder,
    animateLabel,
    subLabel,
    helperText,
    bulbInfoMessage,
    tooltip,
    width,
  } = props;

  const {
    error,
    focused,
    handleBlur,
    handleChange,
    handleClick,
    onFocus,
    labelDense,
    handlePaste,
  } = useEmailControl(props);

  return (
    <FormControl
      fullWidth
      className={classNames(classes.root, {
        [classes.withAdornment]: animateLabel,
      })}
    >
      <ControlContainer
        inputId={input.name}
        tooltip={tooltip}
        label={animateLabel ? undefined : label}
        subLabel={subLabel}
        helperText={helperText}
        tipMessage={
          bulbInfoMessage ? (
            <TipMessage content={bulbInfoMessage.content} icon={<History />} />
          ) : undefined
        }
        floating
        floated
        focused={focused}
        meta={meta}
        classes={{
          label: labelDense ? classes.labelDense : classes.label,
        }}
        width={width}
      >
        {!animateLabel && (
          <MailOutline
            className={classNames(
              {
                [classes.activeIcon]:
                  props.isQuestionValid && UtilService.hasValue(input.value),
              },
              classes.icon
            )}
          />
        )}
        <TextField
          id={input.name}
          fullWidth
          disabled={disabled}
          {...input}
          label={animateLabel ? label : undefined}
          InputLabelProps={{
            shrink: focused || UtilService.hasValue(input.value),
          }}
          InputProps={
            animateLabel
              ? {
                  startAdornment: (
                    <InputAdornment position="start" disablePointerEvents>
                      <MailOutline className={classes.adornmentIcon} />
                    </InputAdornment>
                  ),
                }
              : undefined
          }
          inputProps={{
            id: input.name,
            className: classNames(
              { [classes.textField]: !animateLabel },
              {
                [classes.textFieldElevated]: isSafariOrIOS(),
              }
            ),
          }}
          onChange={handleChange}
          onBlur={(event) => handleBlur(event.target.value)}
          onClick={handleClick}
          onFocus={onFocus}
          onPaste={handlePaste}
          error={error}
          variant="outlined"
          margin="dense"
          autoComplete="email"
          placeholder={
            animateLabel ? undefined : placeholder || LabelEnum.EmailPlaceholder
          }
        />
      </ControlContainer>
    </FormControl>
  );
}
